import React from 'react';
import PanelHelpBadge from '../../PanelHelpBadge';

export default function SnapshotCardBase({ title, help, primary, metrics, onOpenDrawer }) {
  return (
    <article className="min-h-[220px] rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-[#101922]">
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-sm font-black text-slate-900 dark:text-white">{title}</h3>
        <PanelHelpBadge
          title={title}
          description={help.description}
          interpretation={help.interpretation}
          metricExample={help.metricExample}
        />
      </div>

      <p className="mt-3 text-3xl font-black text-slate-900 dark:text-white">{primary}</p>

      <ul className="mt-3 space-y-1.5">
        {metrics.map((item) => (
          <li key={item.label} className="flex items-center justify-between text-sm">
            <span className="text-slate-500 dark:text-slate-400">{item.label}</span>
            <span className="font-black text-slate-900 dark:text-white">{item.value}</span>
          </li>
        ))}
      </ul>

      <button
        type="button"
        onClick={onOpenDrawer}
        className="mt-4 inline-flex items-center text-xs font-bold text-primary hover:underline"
      >
        Detaya git →
      </button>
    </article>
  );
}
